
import { isTouchScreen } from 'bits/browser'
import { formats } from 'bits/formats'
import { Component, namespace, Vue, Watch } from 'bits/vue'
import FormatCard from 'vuecomponents/format_card.vue'
import ProcessedImage from 'vuecomponents/processed_image.vue'

const browser = namespace('browser')

// Different format for ipad view
// Non touchscreen view (resizing - no scroll)
// 1. Desktop
// 2. Ipad
// 3. Phone
// Touchscreen view (enable scroll)
// 1. Ipad (including Ipad pro) --> (display: grid)
// 2. Phones (mobile view) --> (display: flex)

@Component({
  components: { FormatCard, ProcessedImage },
})
export default class FormatCards extends Vue {
  @browser.State windowWidth
  @browser.State windowHeight
  @browser.Getter isSmallerThanTabletPortrait
  @browser.Getter isBiggerThanTabletLandscape
  touchscreen = isTouchScreen()
  formats = formats
  mobileCardWidth = 268
  mobileCardHeight = 400

  get isMonitorOrTabletView(): boolean {
    return !this.touchscreen || (this.touchscreen && !this.isSmallerThanTabletPortrait)
  }

  get extraWidthOfOneCardOnTopRow(): number {
    /**
     * - Margin of a card is 10px in desktop devices
     * -> Total margin = margin left + margin right = 10 + 10 = 20px
     * - Margin of a card is 8px in tablets devices
     * -> Total margin = margin left + margin right = 8 + 8 = 16px
     * We want to covert the old layout with 8 formats (top 4, bottom 4)
     * to a new one with 7 formats (top 3, bottom 4) and keep the width of 2 rows equal
     * -> each card of the top row have to plus with total margin of a card divide 3
     */
    return !this.isBiggerThanTabletLandscape ? 16 / 3 : 20 / 3
  }

  get formatCardWidth(): number {
    if (this.isSmallerThanTabletPortrait) {
      return Math.floor(this.windowWidth / 2.4)
    } else if (!this.isBiggerThanTabletLandscape) {
      return Math.floor(this.windowWidth / 4.6)
    } else if (this.windowWidth < 1200) {
      return Math.floor(this.windowWidth / 6.3)
    } else if (this.windowWidth < 1500) {
      return Math.floor(this.windowWidth / 5.9)
    }
    return Math.floor(this.windowWidth / 5.5)
  }

  get formatCardWidthOnTopRow(): number {
    /**
     * We want to covert the old layout with 8 formats (top 4, bottom 4)
     * to a new one with 7 formats (top 3, bottom 4) and keep the width of 2 rows equal
     * -> each card of the top row have to multiple 4 and divide 3, then plus extraWidthOfOneCardOnTopRow
     */
    return (this.formatCardWidth * 4) / 3 + this.extraWidthOfOneCardOnTopRow
  }

  get formatCardHeight(): number {
    let ratio = 5.4 / 10
    if (this.isSmallerThanTabletPortrait) {
      ratio = 0.65
    } else if (!this.isBiggerThanTabletLandscape) {
      ratio = 0.63
    } else if (this.windowWidth < 1500) {
      ratio = 0.56
    }

    return Math.floor(this.formatCardWidth * ratio)
  }

  get formatCardHeightOnTopRow(): number {
    return Math.floor((this.formatCardHeight * 4) / 3)
  }

  get formatCardTransforms(): object {
    return { width: this.formatCardWidth, height: this.formatCardHeight }
  }

  get formatCardTransformsOfTopItem(): object {
    return { width: this.formatCardWidthOnTopRow, height: this.formatCardHeightOnTopRow }
  }

  get formatCardWidthMobileView(): number {
    return this.mobileCardWidth
  }

  get formatCardHeightMobileView(): number {
    return this.mobileCardHeight
  }

  get formatCardTransformsMobileView(): object {
    return { width: this.mobileCardWidth, height: this.mobileCardHeight }
  }

  @Watch('windowWidth')
  onWindowWidthChange(): void {
    this.touchscreen = isTouchScreen()
  }

  isCardOnTopRowOfMonitorOrTabletView(viz: string): boolean {
    const topFormats = ['grid', 'free', 'shelf']
    return !this.isSmallerThanTabletPortrait && topFormats.includes(viz)
  }
}
